export class AgeType {
  private constructor(readonly name: string, readonly code: string) {}

  static all(): AgeType[] {
    return [
      new AgeType('13-17', '13-17'),
      new AgeType('18-24', '18-24'),
      new AgeType('25-34', '25-34'),
      new AgeType('35-44', '35-44'),
      new AgeType('45-54', '45-54'),
      new AgeType('55-64', '55-64'),
      new AgeType('65+', '65+'),
    ];
  }
}
